import { useContext, useState, useEffect } from "react";
import Logout from "./Logout.js";
import { NotificationPopup } from '../Pages/Notification';
import { IoIosNotifications } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { UserContext } from "../Context/UserContext.js";
import { TechB_Logo } from "../Assets";
import { HOME } from "../routes.js";
import { HEADER_ITEMS } from "../Constants/headerItems.js";
import { useNotifications } from "../Context/NotificationContext.js";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const { user } = useContext(UserContext);
  const { unreadCount, fetchUnreadCount,} =
    useNotifications();

  const toggleMenu = () => {
    setIsMenuOpen((isMenuOpen) => !isMenuOpen);
  };

  useEffect(() => {
    fetchUnreadCount();
  }, []);

  const handleBellClick = () => {
      setShowPopup((prev) => !prev);
  };

  return (
    <nav className="bg-primary border-gray-200 px-4 dark:bg-gray-800 relative z-50">
      <div className="flex justify-between items-center h-16">
        {/* Logo */}
        <NavLink to={HOME} className="flex items-center space-x-2">
          <img
            src={TechB_Logo}
            alt="SolarOps Logo"
            className="h-8 w-8 object-contain"
          />
          <span className="self-center text-xl font-semibold whitespace-nowrap text-white">
            RoofTop SolarOps
          </span>
        </NavLink>

        {/* Mobile view: Bell + Menu toggle */}
        <div className="flex items-center gap-3 md:hidden ml-auto pr-2">
          {/* Bell (always visible on mobile) */}
          <button
            type="button"
            className="relative p-2 text-white hover:text-secondary"
            onClick={handleBellClick}
          >
            <IoIosNotifications size={24} />
            {unreadCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs rounded-full px-1 m-2">
                {unreadCount}
              </span>
            )}
          </button>

          {/* Mobile menu toggle */}
          <button
            type="button"
            className="bg-white inline-flex items-center p-2 text-sm text-gray-500 rounded-lg ring-2 ring-gray-200 shadow-sm"
            aria-expanded={isMenuOpen}
            onClick={toggleMenu}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div
            className="fixed inset-0 z-30 md:hidden bg-transparent"
            onClick={() => setIsMenuOpen(false)}
          />
        )}

        {/* Desktop + Mobile menu */}
        <div
          className={`absolute md:static top-full right-0 w-3/4 md:w-auto md:bg-primary bg-white md:text-white text-primary
            transition-all duration-300 ease-in-out overflow-hidden shadow-xl md:shadow-none z-50
            ${
              isMenuOpen ? "block opacity-100" : "hidden md:flex md:opacity-100"
            }
            md:items-center md:ml-auto`}
        >
          <ul className="flex flex-col md:flex-row md:items-center md:space-x-8 p-4 md:p-0 font-medium">

            {HEADER_ITEMS[user?.role]?.map((item, idx) => (
              <li key={idx}>
                <NavLink
                  to={item.route}
                  className={({ isActive }) =>
                    `block py-2 px-3 md:p-0 ${
                      isActive ? "border-b font-bold" : "md:text-white text-primary"
                    }hover:bg-gray-100`
                  }
                >
                  {item.name}
                </NavLink>
              </li>
            ))}

            {/* Desktop Bell */}
            <li className="hidden md:block">
              <button
                type="button"
                className="relative p-2 text-white hover:text-secondary"
                onClick={handleBellClick}
              >
                <IoIosNotifications size={22} />
                {unreadCount > 0 && (
                  <span className="absolute top-0 -right-2 bg-red-600 text-white text-xs rounded-full px-1 m-0">
                    {unreadCount}
                  </span>
                )}
              </button>
            </li>

            {/* Logout for mobile */}
            <li className="py-2 pr-4 pl-3 text-gray-700 hover:bg-gray-50 md:hidden">
              <Logout isMenuOpen={isMenuOpen} />
            </li>

            {/* Logout for desktop */}
            <li className="hidden md:block">
              <Logout isMenuOpen={false} />
            </li>
          </ul>
        </div>
      </div>

      {/* Notification Popup */}
      {showPopup && <NotificationPopup onClose={() => setShowPopup(false)} />}
    </nav>
  );
};

export default Header;
